<div class="header">
  <div class="left">
    <ng-content></ng-content>
  </div>
  <div >
    <button  matTooltip="Domů" matTooltipPosition="below" mat-button class="header-title"  (click)="navigateHome()" [attr.active-color]="'cml-active-white'">CML</button>
  </div>
  <div class="spacer"></div>
  <div class="right">
    <button  matTooltip="Odhlásit se" matTooltipPosition="below" mat-button (click)="logout()" [attr.active-color]="'cml-active-white'"><i class="cml-fw cml-lg cml-power-off" [attr.active-color]="'cml-active-dark-red'"></i>{{ 'AbpIdentity:Logout' | localize | async }}</button>
  </div>
</div>
